import { Component, OnInit } from "@angular/core";
import { DefaultEditor } from "ng2-smart-table";
import { CustomEntityUtils } from './../../custom-entity-utils.service';


@Component({
  templateUrl: './attributejoin.cell.component.html',
})
export class AttributeJoinCellComponent extends DefaultEditor implements OnInit {


public  columna: String;
currentValue: any;
entityValue: any;
targetValue:any;
sourceAttributes = [];
attrSourceSettings = {
  singleSelection: true,
  closeDropDownOnSelection: true,
  allowSearchFilter: true,
  searchPlaceholderText:"Buscar",
  enableCheckAll:false,
  textField:"name"
};

dropdownSettings = {
  singleSelection: true,
  selectAllText:'Select All',
  unSelectAllText:'UnSelect All',
  enableSearchFilter: true,
  labelKey:"name",
  primaryKey:"id",
  searchPlaceholderText:"Buscar",
  text:"Seleccione elemento"
};

entities = [];
targetAttributes = [];



constructor( private customEntityUtils: CustomEntityUtils){
  super();
}

 async ngOnInit() {
    console.log(this.cell)
    if(this.cell.getValue() != null && this.cell.getValue() != '' ){
      this.currentValue = [this.cell.getValue()];
    }

    this.columna =this.cell.getColumn().id;
    switch(this.columna){
      case 'attributeSource':
        this.sourceAttributes = this.customEntityUtils.getAttributeList();
      break;

      case 'relation':
        this.entities = this.customEntityUtils.getCompanyEntities();
        this.entityValue = [this.cell.getValue().entity]
        this.targetAttributes = this.entities.find(e => e.id == this.entityValue[0].id).attributes
        this.targetValue = [this.cell.getValue().attribute]
      break;
    }



  }


  public async changeSelect() {
    switch(this.columna){
      case 'attributeSource':
          if(this.currentValue != null && this.currentValue.length > 0){
            this.cell.newValue = this.currentValue[0];
          }
          break;

      case 'relation':
        this.targetAttributes = this.entities.find(e => e.id == this.entityValue[0].id).attributes
        this.targetValue = []
      break;
  }
  }

  public changeAtributeSelect(){
    if (this.entityValue != null && this.entityValue.length > 0 && this.targetValue != null && this.targetValue.length > 0){
      this.cell.newValue = {entity: this.entityValue[0],attribute: this.targetValue[0],name:this.entityValue[0].name+'-'+ this.targetValue[0].name }

    }else{
      this.cell.newValue = {}

    }
  }
}
